import { Box, Text, useDimensions } from '@chakra-ui/react';
import * as React from 'react';
import Container from '../../../../components/Container';
import PersonBioBanner from './banner';
import Content from './content';
import Detail from './detail';

const TeamBioHero = ({ data }) => {
    const elementRef = React.useRef();
    const contentRef = React.useRef();
    const detailRef = React.useRef();
    const dimensions = useDimensions(elementRef, true);
    const cntDimensions = useDimensions(contentRef, true);

    const y = dimensions?.contentBox.y;

    const cntH = cntDimensions?.contentBox.height || 0;


    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
                <Container>
                    <Box
                        pb={'24'}
                        px={'20px'}
                        pt={'20px'}
                        position={'relative'}
                        height={{ base: 'auto'}}
                        ref={elementRef}
                        id={'profile-container'}
                    >
                        <Box
                            pos={{ base: 'relative' }}
                            top={'20px'}
                            left={{ base: 'none', lg: '0' }}
                            right={{ base: 'none', lg: '0' }}
                            // height={{ lg: `calc(800px - ${fitToHero}px)` }}
                            // minHeight={{ base: 'auto', lg: minimumGridViewHeight }}
                        >
                            <Box mt={'20px'} textAlign={'left'} display={{ lg: 'none', base: 'flex' }} id={'profile-box-mobile'}>
                                <Box pb={'20px'} mt={'20px'}>
                                    <Text mb={'10px'} as={'h1'} fontSize={'14px'} lineHeight={'16.8px'}>
                                        {data?.acf?.job_title}
                                    </Text>
                                    <Text
                                        as={'h2'}
                                        ml={'-4px'}
                                        fontSize={'40px'}
                                        lineHeight={'40px'}
                                        letterSpacing={'-2px'}
                                    >
                                        {data?.acf?.first_name} {data?.acf?.last_name}
                                    </Text>
                                </Box>
                            </Box>
                            <PersonBioBanner data={data} />
                            <Box position={'relative'} height={{ base: 'auto' }} id={'profile-box'}>
                                <Content ref={contentRef} t data={data} />
                                <Detail
                                    data={data}
                                    ref={detailRef}
                                    opacity={y < 0 && y ? 1 : 0}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default TeamBioHero;
